import React from 'react';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import url from 'url';
import defaultSEO from '../../utils/seo';
import { withTranslation } from '../../src/i18n';
import { removeLocaleFromUrl } from '../../utils/route';

require('dotenv').config();

const baseURL = process.env.FRONTBASE_URL;
const baseLocale = 'en';

const SEO = ({ title, description, ogTitle, other, i18n }) => {
  const router = useRouter();
  const locale = i18n.language || baseLocale;
  const asPath = `${baseURL}${router.asPath}`;
  const parsed = url.parse(asPath);
  const pathnameWithoutLocale = removeLocaleFromUrl(parsed.pathname, locale);

  parsed.pathname = `${pathnameWithoutLocale}/${locale}`;

  const canonical = url.format(parsed);

  const seo = defaultSEO({ title, description, canonical, locale, ogTitle });
  return <NextSeo {...seo} {...other} />;
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default withTranslation()(SEO);
